import styled from '@emotion/styled';

export const ListContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  margin-top: var(--topH);
  grid-template-rows: 52px 1fr;
  padding-bottom: 80px;

  /* overflow: ; */
  /* overflow-x: auto; */
  width: auto;
  min-width: 100%;
  padding: 20px var(--padding);
  margin-bottom: calc(80px + 40px);
  margin-top: 20px;
  margin-right: var(--padding);
  /* overflow-x: scroll; */
  overflow-y: hidden;
  /* padding-top: 20px; */
  height: calc(var(--site-height) - var(--regi-nav-height) - 80px);
`;

export const ListWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100px;
`;
